import React, { useState } from "react";
import RequestBuy from "../components/common/requestForm/RequestBuy";
import ProductsFromModel from "../components/common/products/ProductsFromModel";
import RequestGetList from "../components/common/requestForm/RequestGetList";
import { useFormik } from "formik";
import { priceComma } from "../utils/priceComma";
import * as Yup from "yup";
import { httpReauest } from "../utils/httpRequest";
import { Helmet } from "react-helmet";
import { useRouteInfo } from "../hooks/useRouteInfo";

const PayLaterPage = () => {
  const [ourVehicles, setOurVehicles] = useState();
  const [otherVehicles, setOtherVehicles] = useState();
  const { metaData } = useRouteInfo();

  const lazing = [
    { name: "لیزینگ دولتی", precent: 16 },
    { name: "لیزینگ خصوصی", precent: 10 },
    { name: "لیزینگ نمایشگاه", precent: 5 },
  ];
  const VALUE_SIGN_VALIDATION = () => {
    return Yup.object({
      lazing: Yup.string().required("الزامی است"),
      price: Yup.string().required("الزامی است"),
      firstPay: Yup.string().required("الزامی است"),
      time: Yup.string().required("الزامی است"),
    });
  };
  const formik = useFormik({
    initialValues: {
      lazing: "",
      price: "",
      firstPay: "",
      time: "",
    },
    validationSchema: VALUE_SIGN_VALIDATION,
    onSubmit: async (values) => {
      const newPrice = Number(values.price?.replaceAll(",", ""));
      const newfirstPay = Number(values.firstPay?.replaceAll(",", ""));
      if (newfirstPay < (newPrice / 100) * 70) {
        return formik.setFieldError(
          "firstPay",
          "پیش پرداخت باید بیشتر از 70 درصد قیمت باشد"
        );
      }
      const percent = lazing.find((e) => e.name == values.lazing).precent;

      const Allprice = newPrice + (newPrice / 100) * 16;
      const priceByTime = (Allprice - newfirstPay) / values.time;
      setResult({
        price: newPrice,
        time: values.time,
        Allprice,
        lazing: values.lazing + " با سود " + percent + "درصد",
        firstPay: newfirstPay,
        priceByTime,
      });

      const min_price = newPrice / 1000000000 - 1;
      const max_orice = newPrice / 1000000000 + 1;

      await httpReauest(
        "GET",
        "/vehicle?min_price=" + min_price + "&max_price=" + max_orice,
        {},
        {}
      ).then(({ data }) => {
        setOurVehicles(data?.data.slice(0, 4));
      });

      await httpReauest("GET", "/vehicle", {}, {}).then(({ data }) => {
        setOtherVehicles(data?.data?.slice(0, 4));
      });
    },
  });

  const [result, setResult] = useState({
    lazing: "",
    price: "",
    firstPay: "",
    time: "",
    Allprice: "",
    priceByTime: "",
  });

  function handleChange(params, fild) {
    const value = params.target.value;
    const formattedValue = (
      Number(value.replace(/\D/g, "")) || ""
    ).toLocaleString();
    formik.setFieldValue(fild, formattedValue);
  }
  return (
    <div className="py-8 container_1">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      <img
        src="/paylater.jpg"
        className="w-full  object-cover my-10 rounded-[10px] center"
        alt=""
      />
      <div className="mt-12 mb-12">
        <h1 className="title">{metaData?.h1}</h1>
        <div className=" grid grid-cols-3 gap-8 mt-5">
          <span
            id="خودرو اقتصادی"
            className={`border-brand flex flex-col gap-4 items-center justify-center py-7`}
          >
            <h3 className="font-[700] text-[24px]">لیزینگ دولتی</h3>
            <p className="text-red-600">ظرفیت تکمیل شده است!</p>
          </span>
          <span
            id="خودرو کاری"
            className={`border-brand flex flex-col gap-4 items-center justify-center py-7`}
          >
            <h3 className="font-[700] text-[24px]">لیزینگ خصوصی</h3>
            <p className="text-green-600">بیش از 100 نفر ظرفیت دارد</p>
          </span>
          <span
            id="خودرو جدید"
            className={`border-brand flex flex-col gap-4 items-center justify-center py-7`}
          >
            <h3 className="font-[700] text-[24px]">لیزینگ نمایشگاه</h3>
            <p className="text-green-600">بیش از 100 نفر ظرفیت دارد</p>
          </span>
        </div>
      </div>
      <div className="my-12 grid-cols-12 grid">
        <span className="border-brand p-5 grid grid-cols-12 col-span-12 lg:col-span-10 lg:col-start-2">
          <h2 className="text-[24px] font-[600] text-center col-span-12 pb-12">
            محاسبه گر اقساط
          </h2>
          <form
            onSubmit={formik.handleSubmit}
            className="grid grid-cols-2 col-span-8 gap-12 col-start-3"
          >
            <span className="relative">
              <select
                className={`xl:min-w-[210px] w-full form-brand `}
                placeholder="مثلا : بنز باری 10 تن مدل 1380"
                name="lazing"
                id="lazing"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.lazing}
              >
                <option></option>
                {lazing.map((e) => (
                  <option value={e.name}>{e.name}</option>
                ))}
              </select>
              {formik.errors.lazing && formik.touched.lazing && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.lazing}
                </small>
              )}
              <p className="on-border">نوع لیزینگ</p>
            </span>
            <span className="relative">
              <input
                className={`xl:min-w-[210px] w-full form-brand `}
                placeholder="مثلا : 3.000.000.000"
                name="price"
                id="price"
                onChange={(e) => handleChange(e, "price")}
                onBlur={formik.handleBlur}
                value={formik.values.price}
              />
              {formik.errors.price && formik.touched.price && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.price}
                </small>
              )}
              <p className="on-border">مبلغ خودرو</p>
            </span>
            <span className="relative">
              <input
                className={`xl:min-w-[210px] w-full form-brand `}
                placeholder="مثلا : 2.500.000.000"
                name="firstPay"
                id="firstPay"
                onChange={(e) => handleChange(e, "firstPay")}
                onBlur={formik.handleBlur}
                value={formik.values.firstPay}
              />
              {formik.errors.firstPay && formik.touched.firstPay && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.firstPay}
                </small>
              )}
              <p className="on-border">پیش پرداخت</p>
            </span>
            <span className="relative">
              <input
                className={`xl:min-w-[210px] w-full form-brand `}
                placeholder="مثلا : 10 "
                name="time"
                type="number"
                id="time"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.time}
              />
              <p className="absolute translate-y-[-50%] top-[24px] left-4">
                ماهه
              </p>
              {formik.errors.time && formik.touched.time && (
                <small style={{ color: "red", fontSize: "14px" }}>
                  {formik.errors.time}
                </small>
              )}
              <p className="on-border">اقساط</p>
            </span>
            <span className="col-span-2 flex justify-center">
              <button type="submit" className="btn-brand w-[220px]">
                محاسبه
              </button>
            </span>
          </form>
          {result.Allprice && (
            <span className="col-span-10 col-start-2 grid-cols-2 grid gap-8 mt-8 gap-x-32">
              <span className="flex justify-between text-[20px]">
                <p className=" font-[700]">نوع لیزینگ</p>
                <p className="text-[18px]">{result.lazing}</p>
              </span>
              <span className="flex justify-between text-[20px]">
                <p className=" font-[700]">مبلغ خودرو</p>
                <p className="text-[18px]">{priceComma(result.price, 2)}</p>
              </span>
              <span className="flex justify-between text-[20px]">
                <p className=" font-[700]">پیش پرداخت</p>
                <p className="text-[18px]">{priceComma(result.firstPay, 2)}</p>
              </span>
              <span className="flex justify-between text-[20px]">
                <p className=" font-[700]">اقساط</p>
                <p>{result.time} ماهه</p>
              </span>
              <span className="flex justify-between text-[20px]">
                <p className=" font-[700]">مبلغ هر قسط</p>
                <p className="text-[18px]">
                  {priceComma(result.priceByTime, 2)}
                </p>
              </span>
              <span className="flex justify-between text-[20px]">
                <p className=" font-[700]">جمع کل اقساط</p>
                <p className="text-[18px]">{priceComma(result.Allprice, 2)}</p>
              </span>
              <span className="col-span-2 text-[#5B5B5B] py-3 text-center">
                برای کسب اطلاعات دقیق تر درباره شرایط اقساط و نحوه پرداخت
                میتوانید با کارشناسان ۱۹۲۴ تماس بگیرید. هدف ما رضایت و حفظ
                سرمایه شماست.
              </span>
            </span>
          )}
        </span>
      </div>
      <RequestBuy />
      <div className="my-12">
        {ourVehicles && (
          <ProductsFromModel data={ourVehicles} title={"پیشنهاد ما"} />
        )}
      </div>
      {otherVehicles && (
        <div className="my-12">
          <ProductsFromModel data={otherVehicles} title={"دیگر محصولات"} />
        </div>
      )}
      <RequestGetList />
      <div className="my-12">
        <h3 className="title">
          با خرید قسطی ماشین سنگین، پایتان به جاده زودتر باز می‌شود.
        </h3>
        <p className="desc">
          اگر تصمیم دارید ماشین سنگین بخرید، اما پرداخت هزینه به صورت یک‌جا برای
          شما دشوار است، 1924 شرایط خرید اقساطی را برای شما فراهم کرده‌ است. مهم
          نیست چه نوع ماشینی را در نظر دارید، می‌توانید کامیونت، کامیون، و یا
          کشنده را کاملا به صورت اقساط در 1924 بخرید و از مزایای معامله خود سود
          ببرید.
        </p>
        <p className="desc">
          ما شرایط اقساطی را براساس شرایط خریدار می‌چینیم. رضایت خریدار نسبت به
          سود واسط برای ما اولویت دارد. درآمد و نوع فعالیت شما در تعیین شرایط
          خرید اقساطی نقش پر رنگی دارد که در هنگام معامله آن‌ها را در نظر
          می‌گیریم. همچنین، این شرایط در تمام طول سال پا بر جاست. شما می‌توانید
          در هر زمان، به صورت حضوری به 1924 مراجعه کنید و یا با کارشناسان ما
          تماس بگیرید و از جزئیات خرید قسطی بنا بر شرایط مالی و کاری خودتان آگاه
          شوید.
        </p>
      </div>
    </div>
  );
};

export default PayLaterPage;
